import React from "react"
import { useTranslation } from "react-i18next"
const MarketsDisplayListComponent = () => {
  const { t } = useTranslation()

  return (
    <div>
      <ul className="market-ul">
        <div className="market-ul-text1">{t("mk.all_active_regions")}</div>
        <li>{t("mk.active_physician")}</li>
      </ul>
      <ul className="market-ul">
        <div className="market-ul-text2">
          {t("mk.united_states_english_only")}
        </div>
        <li>{t("mk.nurse_practitioner")}</li>
        <li>{t("mk.nursing")}</li>
        <li>{t("mk.physician_assistant")}</li>
        <li>{t("mk.hospital_administration")}</li>
        <li>{t("mk.psychology")}</li>
        <li>{t("mk.optometry")}</li>
        <li>{t("mk.pharmacy")}</li>
        <li>{t("mk.managed_care")}</li>
        <li>{t("mk.dentistry")}</li>
        <li>{t("mk.practice_management")}</li>
        <li>{t("mk.dental_hygiene")}</li>
        <li>{t("mk.medical_residency_or_fellowship")}</li>
        <li>{t("mk.veterinary_medicine")}</li>
      </ul>
    </div>
  )
}
export default MarketsDisplayListComponent
